import React, { useState } from "react";

import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

import LoginService from "../../services/LoginService";
import constants from "../../config/constants";

import "./ChangePasswordComponent.scss";
import { setPageTitle } from "../../utils/pageTitleHelper";

/* Must mirror UserHelper.checkPassword on the server. */
const POLICY = [
  "At least 10 characters",
  "At least one letter and one digit",
  "At least one uppercase and one lowercase letter",
  "At least one special character"
];

function ChangePasswordComponent() {
  const [validated, setValidated] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [disableSubmit, setDisableSubmit] = useState(false);

  setPageTitle();

  const handleSubmit = (e) => {
    const form = e.currentTarget;
    e.preventDefault();
    e.stopPropagation();

    if (form.checkValidity() !== true) {
      setValidated(true);
      return;
    }

    const newPassword = form.newPassword.value;
    const confirmPassword = form.confirmPassword.value;

    if (newPassword !== confirmPassword) {
      setErrorMessage("Passwords do not match.");
      return;
    }

    setDisableSubmit(true);
    LoginService.changeFirstLoginPassword({ newPassword, confirmPassword })
      .then((response) => {
        window.location = response.data?.data?.redirectionUrl || "/admin/events";
      })
      .catch((err) => {
        setErrorMessage(
          err?.response?.data?.message || "Could not update your password. Please try again."
        );
      })
      .finally(() => {
        setDisableSubmit(false);
      });
  };

  const bodyBgImg = { backgroundImage: `url("${constants.login.defaultBgImage}")` };

  return (
    <div className="wrapper" style={bodyBgImg}>
      <div className="id-card">
        <div className="login-box"></div>
        <div className="login-box-body">
          <div className="bms-admin bms-roleType">Set a new password</div>
          <p className="login-box-msg">
            You are signing in with a default password. Please set a new one to continue.
          </p>
          {errorMessage.length ? <p className="login-box-msg">{errorMessage}</p> : null}
          <ul className="password-policy">
            {POLICY.map((rule) => (
              <li key={rule}>{rule}</li>
            ))}
          </ul>
          <Form className="loginForm" noValidate validated={validated} onSubmit={handleSubmit}>
            <Form.Group controlId="newPassword">
              <Form.Control type="password" required placeholder="New Password" />
              <Form.Control.Feedback type="invalid">
                Please enter a new password
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="confirmPassword">
              <Form.Control type="password" required placeholder="Confirm New Password" />
              <Form.Control.Feedback type="invalid">
                Please confirm your new password
              </Form.Control.Feedback>
            </Form.Group>

            <Button className="btn btn-block loginSubmit" type="submit" disabled={disableSubmit}>
              SET PASSWORD
            </Button>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default ChangePasswordComponent;
